/**
 * GlobalPaywallListener — top-level listener that opens PaywallModal whenever
 * the axios interceptor dispatches the `yumix-paywall-blocked` event.
 *
 * Mounted once near the AppContext provider so it works app-wide.
 */
import React, { useEffect, useState } from 'react';
import PaywallModal from './PaywallModal';
import { useNavigate } from 'react-router-dom';

const GlobalPaywallListener = () => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      setReason(e.detail?.message || '');
      setOpen(true);
    };
    window.addEventListener('yumix-paywall-blocked', handler);
    return () => window.removeEventListener('yumix-paywall-blocked', handler);
  }, []);

  const handleContactCoach = () => {
    setOpen(false);
    navigate('/coach');
  };

  return (
    <PaywallModal
      open={open}
      onClose={() => setOpen(false)}
      reason={reason}
      onContactCoach={handleContactCoach}
    />
  );
};

export default GlobalPaywallListener;
